<template>
  <div class="flex flex-col w-full overflow-x-hidden p-10 pt-0 justify-center">
    <p class="text-4xl font-extrabold text-primary sm:text-5xl">
      Oops!
    </p>
    <div class="sm:ml-6">
      <div class="sm:border-l sm:border-gray-200 sm:pl-6">
        <p class="mt-2 text-lg text-gray-500 dark:text-gray-400">
          Looks like you have not been assigned a site at this CruzControl location
        </p>
      </div>
      <div class="mt-6 flex items-center justify-center gap-x-6">
        <VButton
          @click="routeToPortal"
          label="Back to Portal"
          icon="fa-regular fa-rectangle-history" icon-first
          size="lg" icon-size="lg"
          color="secondary"
          outlined
          class="fadein mt-7 w-full sm:w-auto"
        />
        <VButton
          @click="routeToSupportPage"
          label="Contact Support"
          icon="fa-regular fa-headset" icon-first
          size="lg" icon-size="lg"
          color="white"
          outlined
          class="fadein mt-7 w-full sm:w-auto"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex"
import VButton from "@/components/Buttons/Button/VButton.vue"
import sls from "@/store/storage"

export default {
  name: "NoAvailableSites",
  components: {
    VButton
  },
  ...mapMutations([
    "setActiveSite"
  ]),
  methods: {
    routeToPortal() {
      localStorage.removeItem("cruzcontrolSite");
      sls.remove("cruzcontrolSite");
      this.setActiveSite(null);
      location.href = "https://portal.cruzcontrol.app"
    },
    routeToSupportPage() {
      this.$router.push("/support")
    }
  }
};
</script>